module.exports = __webpack_public_path__ + "img/pc_bg.5501966b.png";